import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Cookie } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Cookies = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Link
          to="/"
          className="inline-flex items-center text-primary-red hover:text-primary-red-dark mb-8 transition-colors"
        >
          <ArrowLeft className="mr-2" size={20} />
          Retour à l'accueil
        </Link>

        <article className="prose prose-lg max-w-none">
          <div className="flex items-center space-x-3 mb-6">
            <Cookie className="text-primary-red" size={32} />
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-0">
              Politique des cookies
            </h1>
          </div>

          <div className="text-sm text-gray-500 mb-8">
            Dernière mise à jour : 26 novembre 2025
          </div>

          <div className="space-y-6 text-gray-700 leading-relaxed">
            <p>
              Cette politique des cookies explique ce que sont les cookies, comment nous les utilisons 
              sur notre site web parisparihub.com, et comment vous pouvez contrôler leur utilisation.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">
              1. Qu'est-ce qu'un cookie ?
            </h2>

            <p>
              Un cookie est un petit fichier texte stocké sur votre appareil (ordinateur, tablette, 
              smartphone) lorsque vous visitez un site web. Les cookies permettent au site de reconnaître 
              votre appareil et de mémoriser certaines informations sur vos préférences ou vos actions 
              passées.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">
              2. Types de cookies que nous utilisons
            </h2>

            <h3 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              Cookies strictement nécessaires
            </h3>
            <p>
              Ces cookies sont essentiels au fonctionnement du Site. Ils vous permettent de naviguer 
              sur le Site et d'utiliser ses fonctionnalités de base. Sans ces cookies, certains services 
              que vous demandez ne peuvent pas être fournis.
            </p>
            <p>
              Ces cookies ne collectent pas d'informations vous concernant qui pourraient être utilisées 
              à des fins de marketing ou de mémorisation de vos visites sur d'autres sites web.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              Cookies de performance et d'analyse
            </h3>
            <p>
              Ces cookies nous aident à comprendre comment les visiteurs utilisent notre Site en collectant 
              et rapportant des informations de manière anonyme. Ils nous permettent de :
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Compter le nombre de visiteurs et voir comment ils naviguent sur le Site</li>
              <li>Identifier les pages les plus populaires et les moins populaires</li>
              <li>Comprendre comment les visiteurs arrivent sur le Site</li>
              <li>Améliorer le fonctionnement du Site</li>
            </ul>
            <p>
              Toutes les informations collectées par ces cookies sont agrégées et anonymes. Elles ne 
              contiennent aucune information personnelle identifiable.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              Cookies de fonctionnalité
            </h3>
            <p>
              Ces cookies permettent au Site de se souvenir des choix que vous faites (comme votre langue 
              préférée ou votre région) et de fournir des fonctionnalités améliorées et plus personnalisées. 
              Ils peuvent également être utilisés pour mémoriser les modifications que vous apportez à 
              la taille du texte, aux polices et à d'autres parties des pages web que vous pouvez personnaliser.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              Cookies de ciblage et publicitaires
            </h3>
            <p>
              Ces cookies peuvent être définis par nos partenaires publicitaires sur notre Site. Ils peuvent 
              être utilisés par ces entreprises pour créer un profil de vos intérêts et vous montrer 
              des publicités pertinentes sur d'autres sites. Ils ne stockent pas directement d'informations 
              personnelles, mais sont basés sur l'identification unique de votre navigateur et de votre 
              appareil Internet.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">
              3. Cookies tiers
            </h2>

            <p>
              En plus de nos propres cookies, nous pouvons également utiliser divers cookies tiers pour 
              nous aider à analyser l'utilisation du Site et à améliorer votre expérience. Ces cookies 
              tiers sont définis par des domaines autres que parisparihub.com.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              Google Analytics
            </h3>
            <p>
              Nous utilisons Google Analytics pour analyser l'utilisation de notre Site. Google Analytics 
              utilise des cookies pour collecter des informations sur la façon dont les visiteurs utilisent 
              notre Site. Ces informations sont utilisées pour compiler des rapports et nous aider à 
              améliorer le Site.
            </p>
            <p>
              Pour plus d'informations sur la façon dont Google utilise les données collectées via Google 
              Analytics, consultez la politique de confidentialité de Google : 
              <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-primary-red hover:underline ml-1">
                https://policies.google.com/privacy
              </a>
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">
              4. Durée de conservation des cookies
            </h2>

            <p>
              Les cookies que nous utilisons ont différentes durées de vie :
            </p>

            <ul className="list-disc list-inside space-y-2 ml-4">
              <li><strong>Cookies de session :</strong> Ces cookies sont temporaires et sont supprimés lorsque vous fermez votre navigateur.</li>
              <li><strong>Cookies persistants :</strong> Ces cookies restent sur votre appareil pendant une période déterminée ou jusqu'à ce que vous les supprimiez manuellement. La durée de conservation varie selon le type de cookie et peut aller de quelques jours à plusieurs années.</li>
            </ul>

            <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">
              5. Comment gérer les cookies
            </h2>

            <p>
              Vous avez le contrôle sur les cookies. La plupart des navigateurs web acceptent automatiquement 
              les cookies, mais vous pouvez généralement modifier les paramètres de votre navigateur pour 
              refuser les cookies si vous le souhaitez.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              Paramètres du navigateur
            </h3>
            <p>
              Vous pouvez configurer votre navigateur pour qu'il vous avertisse lorsque des cookies sont 
              envoyés ou pour qu'il refuse tous les cookies. Voici comment procéder pour les principaux 
              navigateurs :
            </p>

            <ul className="list-disc list-inside space-y-2 ml-4">
              <li><strong>Google Chrome :</strong> Paramètres > Confidentialité et sécurité > Cookies et autres données de sites</li>
              <li><strong>Mozilla Firefox :</strong> Options > Vie privée et sécurité > Cookies et données de sites</li>
              <li><strong>Safari :</strong> Préférences > Confidentialité > Cookies et données de sites web</li>
              <li><strong>Microsoft Edge :</strong> Paramètres > Cookies et autorisations de site > Cookies et données de sites</li>
            </ul>

            <p>
              <strong>Note importante :</strong> Si vous choisissez de désactiver les cookies, certaines 
              fonctionnalités du Site peuvent ne pas fonctionner correctement. Par exemple, vos préférences 
              peuvent ne pas être sauvegardées, et certaines pages peuvent ne pas s'afficher correctement.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              Outils de gestion des cookies
            </h3>
            <p>
              Vous pouvez également utiliser des outils tiers pour gérer les cookies, tels que :
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Des extensions de navigateur qui bloquent les cookies tiers</li>
              <li>Des services de gestion des préférences de cookies</li>
            </ul>

            <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">
              6. Consentement aux cookies
            </h2>

            <p>
              En continuant à utiliser notre Site après avoir été informé de notre utilisation des cookies, 
              vous consentez à l'utilisation de cookies conformément à cette politique. Si vous ne 
              consentez pas à l'utilisation de cookies, veuillez configurer votre navigateur en conséquence 
              ou cesser d'utiliser le Site.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">
              7. Modifications de cette politique
            </h2>

            <p>
              Nous pouvons modifier cette politique des cookies de temps à autre pour refléter les changements 
              dans notre utilisation des cookies ou pour d'autres raisons opérationnelles, légales ou 
              réglementaires. Toute modification sera publiée sur cette page avec une date de mise à jour 
              révisée.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">
              8. Contact
            </h2>

            <p>
              Pour toute question concernant notre utilisation des cookies, contactez-nous :
            </p>

            <div className="bg-gray-50 rounded-lg p-6 mt-4">
              <p className="font-semibold text-gray-900">ParisPari Hub</p>
              <p className="text-gray-700">Email : <a href="mailto:info@parisparihub.com" className="text-primary-red hover:underline">info@parisparihub.com</a></p>
              <p className="text-gray-700">Téléphone : <a href="tel:+33412407011" className="text-primary-red hover:underline">+33 4 12 40 70 11</a></p>
              <p className="text-gray-700">Adresse : Paris, France</p>
            </div>
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
};

export default Cookies;

